import s from "./ProjectFormPage.module.css";

export const projectFormSteps = [
  "Content",
  "Availability",
  "Specialist Scope",
  "Pricing",
  "Rules",
  "Courses",
  "Quiz",
  "Tags",
  "Review & Save",
] as const;

export type ProjectFormStep = (typeof projectFormSteps)[number];

type ProjectFormStepperProps = {
  activeStep: ProjectFormStep;
  onStepChange: (step: ProjectFormStep) => void;
};

const ProjectFormStepper = ({
  activeStep,
  onStepChange,
}: ProjectFormStepperProps) => {
  return (
    <nav className={s.stepper} aria-label="Project form steps">
      {projectFormSteps.map((step, index) => (
        <button
          key={step}
          type="button"
          className={`${s.stepButton} ${
            activeStep === step ? s.activeStepButton : ""
          }`}
          onClick={() => onStepChange(step)}
          aria-current={activeStep === step ? "step" : undefined}
        >
          <span className={s.stepIndex}>{index + 1}</span>
          <span className={s.stepTitle}>{step}</span>
        </button>
      ))}
    </nav>
  );
};

export default ProjectFormStepper;
